













import Vue from 'vue'

interface loading {
  loading: boolean | string
}

export default Vue.extend({
  name: 'BoardTitle',
  data: function (): loading {
    return {
      loading: false
    }
  },
  computed: {
    title() {
      if(!this.$store.state.currentBoard || !this.$store.state.currentBoard.id) return 'loading...'
      return this.$store.state.currentBoard.name
    }
  },
  methods: {
    changeBoardName: function (value: any) {
      if (typeof value !== 'string') return

      this.loading = 'secondary'
      this.$store.dispatch('updateBoardName', value).then(() => {
          this.loading = false
        }
      )
    }
  }
})
